module.exports = __webpack_public_path__ + "8438bc3f27fff7a3988c53629a7d5dc9.pdf";